module.exports = __webpack_public_path__ + "img/GM.52b6596e.svg";